module.exports = __webpack_public_path__ + "static/media/error.97d51ac4.svg";